import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';

import Iconify from 'src/components/iconify';

interface Props {
  // The pictures, as data: URIs - see splitBodyForSms.
  sources: string[];
  // Omitted where the list only previews what the send works out for itself.
  onRemove?: (src: string) => void;
}

/*
  The pictures a text will carry, listed under its body.

  A text has nowhere in its words to put a picture, so each one goes as an attachment and the
  message goes out as an MMS. Shown here so neither comes as a surprise - and, where the sender can
  do something about it, so a picture meant only for the email can be left off the text.
*/
export default function SmsImageList({ sources, onRemove }: Props) {
  if (!sources.length) return null;

  return (
    <Stack spacing={0.5} sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary">
        Images ({sources.length}) - sent as picture attachments
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {sources.map((src) => (
          <Box
            key={src}
            sx={{
              position: 'relative',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 1,
              p: 0.5,
            }}
          >
            <Box
              component="img"
              src={src}
              alt=""
              sx={{ display: 'block', maxHeight: 96, maxWidth: 160 }}
            />
            {onRemove && (
              <Tooltip title="Leave off the text">
                <IconButton
                  size="small"
                  onClick={() => onRemove(src)}
                  sx={{ position: 'absolute', top: 2, right: 2, bgcolor: 'background.paper' }}
                >
                  <Iconify icon="eva:close-fill" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
